module.exports = __webpack_public_path__ + "static/img/gold-reward.119c3b80.png";